export default __webpack_public_path__ + "static/media/default.a1af2775b6e62acc02b2e41bcbbbef37.png";